<template>
    <div class="vant-card">
        <div class="dataFrom">
             <van-cell-group>
                <van-field v-model="from.name" label="代理商" placeholder="请输入代理商名字" />
            </van-cell-group>
        </div>
        <mt-button type="primary" size="large" @click="handleSearch">搜索</mt-button>
        <div class="addUser" @click="add">新增代理商</div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了"  @load="onLoad" >
            <div class="content" v-for="item in dataList" :key="item.id">
                <div class="vant-v">
                    <van-row>
                        <van-col span="20">{{item.name}}</van-col>
                        <van-col span="4">{{item.profit}}%</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="18">{{item.sysUserAccountName}}</van-col>
                        <van-col span="6" @click.native="edit(item)">编辑</van-col>
                    </van-row>
                </div>
            </div>
        </van-list>
        <van-overlay :show="isShow" @click="isShow = false" >
            <div class="overlay" @click.stop :style="{height: !!dataFrom.id?'350px':'400px'}">
                <div class="title">
                    <van-row>
                        <van-col span="10">{{!!dataFrom.id?'编辑':'新增'}}代理商</van-col>
                        <van-col span="14"><van-icon name="close"  @click="isShow = false" /></van-col>
                    </van-row> 
                </div>
                <van-cell-group>
                    <van-field v-model="dataFrom.name" :disabled="dataFrom.id" label="代理商名称" placeholder="请输入代理商名称" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="dataFrom.sysUserAccountName" :disabled="dataFrom.id" label="代理商账号" placeholder="请输入代理商账号" />
                </van-cell-group>
                <van-cell-group v-if="!dataFrom.id">
                    <van-field v-model="dataFrom.sysUserAccountPwd" label="代理商密码" type="password"  placeholder="请输入代理商密码" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="dataFrom.sysUserMobile" label="代理商手机号" type="tel" placeholder="请输入代理商手机号" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="dataFrom.profit" label="销售折扣(%)" type="number" placeholder="请输入销售折扣" />
                </van-cell-group>
                <mt-button type="primary" size="large" @click.prevent="addUserData" v-if="!dataFrom.id">新增</mt-button>
                <mt-button type="primary" size="large" @click.prevent="editUserData" v-if="!!dataFrom.id">编辑</mt-button>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest} from '@/api/agent.js'
export default {
    name:'card',
    data(){
        return{
            dataFrom:{},
            from:{},
            isShow:false,
            dataList:[],
            pageNo: 0,
            allPage: 0,
            perPageNum: 10,
            loading:false,
            finished:false,
        }
    },
    created(){
    },
    methods:{
        // 初始化数据
        getSimDistributRecordHandler(){
            var data = {
                pageNo: this.pageNo,
		        name:this.from.name,
                perPageNum: this.perPageNum
            }
            wxRequest("agent/account/next/list", data, "post").then(res => { 
                if(res.data.code == 200){
                    this.loading = false;
                    if(res.data.data.totalNum === 0){
                        this.finished = true;
                        return
                    }
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.finished = true;
                    }
                    this.dataList = this.dataList.concat(res.data.data.resultList)                                
                }
            })
        },
        onLoad(){
            if(this.finished) return
            this.pageNo++
            this.loading = true;
            this.getSimDistributRecordHandler()
        }, 
        // 查询
        handleSearch() {
            this.pageNo =1
            this.dataList = []
            this.getSimDistributRecordHandler()
        },
        // 新增
        add(){
            this.isShow= true
            this.dataFrom = {}
        },
        addUserData(){
            if(!this.dataFrom.name){
                Toast('请输入代理商名称')
                return
            }
            if(!this.dataFrom.sysUserAccountName){
                Toast('请输入代理商账号')
                return
            }
            if(!this.dataFrom.sysUserAccountPwd){
                Toast('请输入代理商密码')
                return
            }else if(this.dataFrom.sysUserAccountPwd.length<6){
                Toast('代理商密码的长度至少6位，请重新输入')
                return
            }
            if(!this.dataFrom.sysUserMobile){
                Toast('请输入代理商手机号')
                return
            }else if(!(/^1[3456789]\d{9}$/.test(this.dataFrom.sysUserMobile))){
                Toast('手机号有误，请重新输入')
                return
            }
            if(!this.dataFrom.profit){
                Toast('请输入销售折扣')
                return
            }
            wxRequest("agent/add", this.dataFrom, "post").then(res => { 
                if(res.data.code == 200){      
                    this.$messagebox.alert(res.data.message)      
                    this.isShow=false
                     this.handleSearch()
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        //编辑
        edit(data){
            this.isShow= true
            this.dataFrom = data
        },
        editUserData(){
            if(!this.dataFrom.sysUserMobile){
                Toast('请输入代理商手机号')
                return
            }else if(!(/^1[3456789]\d{9}$/.test(this.dataFrom.sysUserMobile))){
                Toast('手机号有误，请重新输入')
                return
            }
            if(!this.dataFrom.profit){
                Toast('请输入销售折扣')
                return
            }
            wxRequest("agent/update/up", this.dataFrom, "post").then(res => { 
                if(res.data.code == 200){      
                    this.$messagebox.alert(res.data.message)      
                    this.isShow=false
                    this.handleSearch()
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        onConfirm(value) {
            console.log(value)
            this.pickerName = value.text
            this.showPicker = false;
        },
        onCancel() {
             this.showPicker = false;
        },
    }
}
</script>
<style lang="less" scoped>
    .vant-card{
        height:100%;
        background: #F5F5F5;
        padding-top: 10px;
        .dataFrom{
            margin:0px 14px 16px 14px;
            padding:8px;
            padding-left:16px;
            padding-right:16px;
            border-radius: 8px;
            background: #fff;
            [class*=van-hairline]::after{
                border:0
            }
            .van-cell{
                padding-bottom:13px;
                padding-top: 16px;
                :not(:last-child)::after{
                     border:0
                }
            }
            .van-cell-group{
                /deep/.van-cell__title{
                    color:#000;
                }
                /deep/.van-cell__value{
                    .van-field__control{
                        line-height: 24px;
                    }
                }
            }
        }
        button{
            margin: 16px 14px 0 14px;
            width: calc(100% - 28px);
            font-size:14px;
            background:#1677FE;
            border-radius:8px;
            height:48px;
        }
        .addUser{
            color: #1677FE;
            font-size:14px;
            height:24px;
            line-height:24px;
            margin-left:14px;
            padding-left: 24px;
            margin-top: 32px;
            margin-bottom: 22px;
            background: url(./../../assets/agent/addUser.png) no-repeat left center;
            background-size:20px 20px;
        }
        .content{
            margin-top:10px;
            margin-left:14px;
            margin-right:14px;
            background:#fff;
            padding:16px;
            border-radius:8px;
            .vant-v{
                .van-row{
                    padding-bottom:8px;
                    .van-col--18{
                        color:#999;
                        font-size:14px;
                    }
                    .van-col--6{
                        color:#1677FE;
                        font-size:14px;
                        text-align:right;
                    }
                    .van-col--20,
                    .van-col--4{
                        color:#000;
                        font-size:14px;
                    }
                    .van-col--4{
                       text-align:right;
                    }
                }
            }
        }
    }
    .overlay{
        background: #fff;
        width: 90%;
        margin: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        height:400px;
        [class*=van-hairline]::after{
            border:0
        }
        .van-cell{
            padding-bottom:13px;
             border-bottom: 1px solid #F4F4F4;
            padding-top: 16px;
            :not(:last-child)::after{
                    border:0
            }
        }
        .van-cell-group{
            /deep/.van-cell__title{
                color:#000;
            }
            /deep/.van-cell__value{
                .van-field__control{
                    line-height: 24px;
                }
            }
        }
        .van-row{
            padding:16px;
            border-bottom: 1px solid #F4F4F4;
            .van-col--16{
                color: #171717;
                text-align: right;
            }
            .van-col--8{
                color: #333;
            }
        }
        .title{
            .van-col--10{
                font-size:16px;
                color: #000;
                font-weight:bold;
            }
            .van-col--14{
                text-align: right;
                .van-icon{
                    font-size:16px;
                }
            }
        }
        .van-row:nth-child(5){
            border-bottom:0;
        }
    }
</style>